export enum SCORECARD_CLASS_MODEL {
    TRANSACTIONAL = 'TRANSACTIONAL',
    PRINCIPAL = 'PRINCIPAL',
    STRATEGIC = 'STRATEGIC',
}

export const SCORECARD_CLASS = [
    {
        name: SCORECARD_CLASS_MODEL.TRANSACTIONAL,
        value: SCORECARD_CLASS_MODEL.TRANSACTIONAL
    },
    {
        name: SCORECARD_CLASS_MODEL.PRINCIPAL,
        value: SCORECARD_CLASS_MODEL.PRINCIPAL
    },
    {
        name: SCORECARD_CLASS_MODEL.STRATEGIC,
        value: SCORECARD_CLASS_MODEL.STRATEGIC
    }
];

export const COMMERCIAL_CLASS = [
    {
        name: SCORECARD_CLASS_MODEL.TRANSACTIONAL,
        value: SCORECARD_CLASS_MODEL.TRANSACTIONAL
    },
    {
        name: SCORECARD_CLASS_MODEL.PRINCIPAL,
        value: SCORECARD_CLASS_MODEL.PRINCIPAL
    },
    {
        name: SCORECARD_CLASS_MODEL.STRATEGIC,
        value: SCORECARD_CLASS_MODEL.STRATEGIC
    },
    {
        name: 'BLANK',
        value: 'BLANK'
    }
];

export const CONSIDER_INTERNAL_EXTERNAL = [
    {
        name: 'GE Internal',
        value: 'GE_INTERNAL'
    },
    {
        name: 'GE External',
        value: 'GE_EXTERNAL'
    }
];

export const CONSIDER_COMPLETE = [
    {
        name: 'Complete Scorecard',
        value: 'COMPLETE'
    },
    {
        name: 'Non Complete Scorecard',
        value: 'NON_COMPLETE'
    }
];

export const LIMIT_TO_SPEND = [
    {
        name: 'ALL',
        value: 0
    },
    {
        name: 'Top 100',
        value: 100
    },
    {
        name: 'Top 50',
        value: 50
    },
    {
        name: 'Top 25',
        value: 25
    },
    {
        name: 'Top 10',
        value: 10
    }
];

export const COE = [
    {
        name: 'Blades',
        value: 1
    },
    {
        name: 'Electrical',
        value: 2
    },
    {
        name: 'Machine Head',
        value: 3
    },
    {
        name: 'Mechanical',
        value: 4
    },
    {
        name: 'All Other',
        value: 5
    }
];

